import CookieStorage from './CookieStorage';

/**
 * Checks for the ability to use sessionStorage, and if it fails, attempts to use
 * cookies instead
 *
 * You must still check that SessionStorage is available before using it because
 * if the user has disabled cookies and storage, SessionStorage will be undefined.
 *
 * Basic usage:
 * Import SessionStorage:
 *     import { SessionStorage } from 'sarsaparilla';
 *
 * Then in your React class, use SessionStorage in the same way you would use
 * window.sessionStorage. It has the same methods as window.sessionStorage.
 *
 * Example:
 *     SessionStorage.setItem('myDog', 'Pearl');
 *     console.log(SessionStorage.getItem('myDog')); // => 'Pearl'
 */

/* eslint-disable no-console */

function createSessionStorage() {
    // 1. Test if we can use sessionStorage
    try {
        window.sessionStorage.setItem('test', 1);
        window.sessionStorage.removeItem('test');
        return window.sessionStorage;
    }
    catch (e) {
        console.warn('sessionStorage is not available. Switching to cookies');
    }

    // 2. Test if tempSessionStorage has already been initialized
    if (window.tempSessionStorage) {
        return window.tempSessionStorage;
    }

    // 3. Test if we can use cookies
    try {
        // Create cookie
        document.cookie = 'cookietest=1';
        // Delete cookie
        document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
        window.tempSessionStorage = new CookieStorage();
        return window.tempSessionStorage;
    }
    catch (e) {
        console.warn('Cookies are not available. SessionStorage is undefined');
    }

    // 4. return undefined because nothing is available
    return undefined;
}

const SessionStorage = createSessionStorage();

export default SessionStorage;
